import React from 'react';
import 'react-block-ui/style.css';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { usePromiseTracker } from 'react-promise-tracker';
import './LoadingIndicator.css';

const LoadingIndicator = ({ loadingInProgress, delay, area, children }) => {
  const options = { delay: delay || 250 }
  if (area) options.area = area
  const { promiseInProgress } = usePromiseTracker(options);

  const fade = !delay || delay > 0

  // use loadingInProgress if supplied, otherwise promisInProgress
  const showSpinner = loadingInProgress === null || loadingInProgress === undefined ? promiseInProgress : loadingInProgress

  return (
    <div className='li-spinner-container'>
      {showSpinner && <div className={`li-spinner ${fade && 'li-spinner-fade'}`}>
        <Loader
          type="Watch"
          color="#5c8bb4"
          height={80}
          width={80}
        />
      </div>}
      {children}
    </div>
  )
}

export default LoadingIndicator